var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgQuickRepliesLeftArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 14,
  viewBox: "0 0 15 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.00004 0.864258V4.34878C2.63427 4.55438 0.333374 6.82307 0.333374 11.0001V12.6096L1.47145 11.4715C2.96933 9.97363 4.79351 9.34605 7.00004 9.58133V13.1359L14.0124 7.0001L7.00004 0.864258ZM8.33337 5.66677V3.80262L11.9876 7.0001L8.33337 10.1976V8.43535L7.7763 8.34251C5.49992 7.96311 3.49632 8.34311 1.80087 9.4778C2.29973 6.90079 4.19961 5.66677 7.6667 5.66677H8.33337Z"
})));
export { SvgQuickRepliesLeftArrow as ReactComponent };
export default __webpack_public_path__ + "18f7de857f2bc02c7b36dc3b4a126b1a.svg";